import * as Sentry from '@sentry/vue';
import { logError } from '@utils/error-tracking';
import { useAppStore } from '@stores/app';

export function waitForAwsWafIntegration() {
	const appStore = useAppStore();

	return new Promise((resolve, reject) => {
		if (!appStore.wafIsLoaded) {
			const maxAttempts = 50; // Maximum number of attempts
			const interval = 100; // Interval in milliseconds between attempts
			let attempts = 0;

			const checkAwsWafIntegration = () => {
				attempts++;
				if (window.AwsWafIntegration) {
					appStore.wafIsLoaded = true;
					Sentry.addBreadcrumb({
						category: 'waf',
						message: 'AWS WAF Integration loaded successfully',
						level: 'info',
						data: { attempts }
					});
					resolve(true);
				} else if (attempts >= maxAttempts) {
					appStore.wafIsLoaded = false;
					const error = new Error('AWS WAF Integration is not available.');
					const wafScriptElement = document.getElementById('waf-script') as HTMLScriptElement | null;
					logError(error, 'error', {
						key: 'waf-integration-timeout',
						data: {
							attempts,
							maxAttempts,
							totalWaitTime: maxAttempts * interval,
							wafScriptElement: !!wafScriptElement,
							scriptLoaded: wafScriptElement?.getAttribute('data-loaded') || null,
							scriptError: wafScriptElement?.getAttribute('data-error') || null,
							windowAwsWafExists: 'AwsWafIntegration' in window,
							documentReadyState: document.readyState
						}
					});
					reject(error);
				} else {
					setTimeout(checkAwsWafIntegration, interval);
				}
			};

			checkAwsWafIntegration();
		} else {
			resolve(true);
		}
	});
}

export function getWafToken() {
	return waitForAwsWafIntegration().then(() => {
		return window.AwsWafIntegration.getToken();
	});
}
